export const START_ROUTES_SEGMENTS = {
  confirmation: 'confirmation',
  outOfJurisdiction: 'out-of-jurisdiction',
  willEstate: 'will-estate',
  invitation: 'invitation',
  account: 'account',
} as const;
